import React from 'react';
import { Flex, FlexRow, Col, Box } from '@edreamsodigeo/prisma-design-system';
import { useFlowTools } from 'flowTools/useFlowTools';
import Carrier from '../Carrier';
import SegmentLocation from '../SegmentLocation';
import DepartureTime from '../DepartureTime';
import DestinationTime from '../DestinationTime';
import SegmentTrip from '../SegmentTrip';
import SegmentDate from '../SegmentDate';

export type SegmentProps = {
  segment: {
    sections: any[];
    departureDate: string;
    arrivalDate: string;
    departure: any;
    destination: any;
    duration: number;
    carriers: any[];
    transportTypes: ('PLANE' | 'TRAIN')[];
  };
  isSem?: boolean;
  isAlternativeItinerary?: boolean;
};

const Segment: React.FC<SegmentProps> = ({
  segment,
  isSem,
  isAlternativeItinerary,
}) => {
  const {
    sections,
    departureDate,
    arrivalDate,
    departure,
    destination,
    duration,
    carriers,
    transportTypes,
  } = segment;
  const numberOfStops = sections.length - 1;
  const { isMobile } = useFlowTools();

  return (
    <Box flexGrow={1}>
      <Flex
        width={'100%'}
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Carrier carriers={carriers} />
        <SegmentDate date={departureDate} isSem={isSem} />
      </Flex>
      <Flex
        width={'100%'}
        flexDirection="column"
        justifyContent="space-between"
        alignItems="center"
        mt={'2x_small'}
      >
        <FlexRow width={'100%'} justifyContent={'space-between'}>
          <Col width="50px">
            <DepartureTime departureDate={departureDate} />
            <Box mt={'minus_tiny'}>
              <SegmentLocation type="DEPARTURE" location={departure} />
            </Box>
          </Col>
          <Col width={isMobile && isAlternativeItinerary ? '56px' : '92px'}>
            <Flex
              height="100%"
              flexDirection={'column'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <SegmentTrip
                transportTypes={transportTypes}
                duration={duration}
                numberOfStops={numberOfStops}
                isAlternativeItinerary={isAlternativeItinerary}
              />
            </Flex>
          </Col>
          <Col width="50px">
            <DestinationTime
              arrivalDate={arrivalDate}
              departureDate={departureDate}
            />
            <Box mt={'minus_tiny'}>
              <SegmentLocation type="ARRIVAL" location={destination} />
            </Box>
          </Col>
        </FlexRow>
      </Flex>
    </Box>
  );
};

export default Segment;
